import React , {useEffect} from 'react';
//import { useParams  , useNavigate } from "react-router-dom";
//import image from "../../../images/img3.jpg";
import { useStateContext } from '../../../context/contextProvider';
import  Skeleton  from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const DetalisClub = () => {
  const { baseUrl , getOneClub , dataOneClub , dataOneClubLoading , dataOneClubErrMsg , dataOneClubShowErrMsg } = useStateContext();
  //let {nameClub} = useParams();
  //let nav = useNavigate();
  useEffect(  () => {
    window.scrollTo(0, 0);
     const idClub = sessionStorage.getItem("ClubId")
      getOneClub(idClub)   
  } , [])
  return (
    <div className="tw-mt-[150px]">
        <div className="tw-w-[80%] sm:tw-w-[95%] tw-mx-auto tw-my-4 tw-p-2 tw-overflow-hidden tw-rounded-md" data-aos="fade-left" data-aos-duration="700">
        <div className={`tw-w-full tw-text-center tw-pb-3 tw-text-red-500 ${dataOneClubShowErrMsg === false ? "tw-hidden" : ""}`}>
        {
            dataOneClubShowErrMsg &&
            dataOneClubErrMsg 
          }
          </div>
            <div className="tw-w-full tw-h-[400px] tw-relative">
              {
                dataOneClubLoading ?
                <>
                <img src={`${baseUrl}${dataOneClub.image}`}  className="tw-w-full tw-h-full tw-object-cover tw-rounded-md" />
                <div className="overImg tw-absolute tw-top-0 tw-right-0 tw-rounded-md tw-bg-transparent-black tw-w-full tw-h-full "></div>
                </>
                :
                <Skeleton className=" tw-w-full tw-h-full" />
              }
            </div>
            <div className="tw-font-bold tw-text-2xl sm:tw-text-xl tw-text-second-zain tw-mt-4 tw-p-2">
                <span className="tw-whitespace-nowrap tw-overflow-hidden tw-text-second-zain tw-font-bold tw-text-xl md:tw-text-lg sm:tw-text-sm tw-py-3 tw-px-2 tw-pr-4 tw-rounded-sm tw-shadow-sm tw-border-r-2 tw-border-second-zain">
                  {dataOneClubLoading ? dataOneClub.club_name : <Skeleton width={200} height={30}/>}
                </span>
            </div>
            <div className=" tw-shadow-md tw-rounded-sm tw-max-h-[600px] tw-overflow-auto tw-p-2 tw-border-gray-50 tw-mt-4 tw-border-t-2 tw-border-t-second-zain">
              {
                  dataOneClubLoading ?
          <div dangerouslySetInnerHTML={{__html: dataOneClub.body}} className="tw-text-gray-500 tw-p-3 tc">   
          </div>
          :
          <Skeleton count={10} height={15} />
              }
        </div>
        </div>
    </div>
  )
}

export default DetalisClub